import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useSetRecoilState} from 'recoil';

import {BrandAddr2, BrandAddr3, IsAreaSelected} from '@/store';

import styles from './styles.module.scss';

export default function KnewRegionBrand() {
  const navigator = useNavigate();
  const setAddr2 = useSetRecoilState(BrandAddr2);
  const setAddr3 = useSetRecoilState(BrandAddr3);
  const setIsAreaSelected = useSetRecoilState(IsAreaSelected);
  const RegionBrandList = [
    {
      title: '성수',
      path: '/brands',
      addr2: 16,
      addr3: 255,
    },
    {
      title: '용산',
      path: '/brands',
      addr2: 21,
      addr3: undefined,
    },
    {
      title: '압구정',
      path: '/brands',
      addr2: 2,
      addr3: 256,
    },
    {
      title: '을지로',
      path: '/brands',
      addr2: 24,
      addr3: 257,
    },
    {
      title: '종로',
      path: '/brands',
      addr2: 23,
      addr3: undefined,
    },
    {
      title: '망원',
      path: '/brands',
      addr2: 13,
      addr3: 258,
    },
    {
      title: '삼각지',
      path: '/brands',
      addr2: 21,
      addr3: 259,
    },
    {
      title: '잠실',
      path: '/brands',
      addr2: 18,
      addr3: 260,
    },
    {
      title: '문래',
      path: '/brands',
      addr2: 20,
      addr3: 261,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>인기 지역</div>
      </div>
      <div className={styles.card_wrapper}>
        {RegionBrandList.map((item, index) => {
          return (
            <div
              className={styles.card}
              key={`regionBrand${index}`}
              onClick={() => {
                setAddr2(item.addr2);
                setAddr3(item.addr3);
                setIsAreaSelected(true);
                navigator(item.path, {
                  state: {
                    prev: 'home',
                  },
                  replace: true,
                });
              }}>
              <div className={styles.cardTitle}>{item.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
